import UnauthorizedRoute from "./UnauthorizedRoute";

export default UnauthorizedRoute;
